import {Tooltip} from 'bootstrap';

var eventSetupInitialized = false;

export function setupEvent() {
    if (eventSetupInitialized) return;
    eventSetupInitialized = true;

    document.querySelectorAll('.input-group input[type="number"]').forEach(input => {
        input.value = 0;
    });

    const radios = document.querySelectorAll('input[name="SelectType"]');

    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            document.querySelectorAll('.select-type').forEach(function (div) {
                div.classList.remove('selected');
                const selectOptions = div.querySelector('.select-options');
                if (selectOptions) {
                    selectOptions.classList.add('d-none');
                }
            });

            if (this.checked) {
                const parent = this.closest('.select-type');
                parent.classList.add('selected');
                const selectOptions = parent.querySelector('.select-options');
                if (selectOptions) {
                    selectOptions.classList.remove('d-none');
                }
            }
        });
    });

    const form = document.querySelector('.tickets-form');

    if (!form) {
        return;
    }
    checkForPostError();
    const overlay = document.getElementById('searchOverlay');
    overlay?.classList.add('visually-hidden');

    const overlayMessage = document.getElementById('overlayMessage');
    if (overlayMessage) {
        overlayMessage.textContent = 'Söker biljetter...';
    }

    if (module.hot) {
        module.hot.accept();
    }

    function updateScrollShadows(navEl) {
        const scrollLeft = navEl.scrollLeft;
        const scrollWidth = navEl.scrollWidth;
        const clientWidth = navEl.clientWidth;

        const atStart = scrollLeft <= 0;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 1; // small buffer

        navEl.classList.toggle('nav-scroll-shadow-left', !atStart);
        navEl.classList.toggle('nav-scroll-shadow-right', !atEnd);
    }

    const nav = document.querySelector('.nav-scroll-check');

    if (nav) {
        // Initial check
        updateScrollShadows(nav);

        // Re-check on scroll and resize
        nav.addEventListener('scroll', () => updateScrollShadows(nav));
        window.addEventListener('resize', () => updateScrollShadows(nav));
    }

    document.querySelectorAll('.accordion-button').forEach(button => {
        button.addEventListener('click', event => {
            event.preventDefault();
        });
    });

    const toggles = document.querySelectorAll('.accordion-button');

    toggles.forEach((btn) => {
        const iconPlus = btn.querySelector('.icon-plus');
        const iconMinus = btn.querySelector('.icon-minus');

        const updateIcon = () => {
            const isExpanded = btn.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                iconPlus?.classList.add('d-none');
                iconMinus?.classList.remove('d-none');
            } else {
                iconPlus?.classList.remove('d-none');
                iconMinus?.classList.add('d-none');
            }
        };

        // Initial state
        updateIcon();

        btn.addEventListener('click', () => {
            // Wait for Bootstrap to update aria-expanded
            setTimeout(updateIcon, 10);
        });
    });

    configureFormInputs();

    // --- Hidden field sync logic ---
    function syncHiddenTicketFields() {
        document.querySelectorAll('.ticket-quantity-input').forEach(function (input) {
            var idx = input.getAttribute('data-ticket-index');
            var hidden = document.querySelector('.ticket-quantity-hidden[data-ticket-index="' + idx + '"]');
            if (hidden) hidden.value = input.value;
        });
    }

    // Sync on input change as well (for live updates)
    document.querySelectorAll('.ticket-quantity-input').forEach(function (input) {
        input.addEventListener('input', function () {
            var idx = input.getAttribute('data-ticket-index');
            var hidden = document.querySelector('.ticket-quantity-hidden[data-ticket-index="' + idx + '"]');
            if (hidden) hidden.value = input.value;
        });
    });

    const cancelBtn = document.getElementById('cancelSearch');
    let controller = null;

    if (form && form.dataset.initOnce !== 'true') {
        form.addEventListener('submit', async (e) => {
            e.preventDefault(); // Prevent default form submission
            form.dataset.initOnce = 'true';

            syncHiddenTicketFields();

            if (overlay) {
                overlay.classList.remove('visually-hidden');
            }
            controller = new AbortController();
            const signal = controller.signal;

            reindexTicketInputs();

            const formData = new FormData(form);
            
            const query = new URLSearchParams(formData).toString();
            const selectedTickets = getSelectedTickets(); // Collect ticket data

            if (selectedTickets.length > 0) {
                try {
                    const response = await fetch(form.action, {
                        method: 'POST',
                        body: query,
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "X-Requested-With": "XMLHttpRequest"
                        },
                        signal
                    });

                    if (response.ok) {
                        const result = await response.json();
                        const {error, redirectUrl} = result;

                        if (redirectUrl) {
                            const overlayMessage = document.getElementById('overlayMessage');
                            if (overlayMessage) overlayMessage.textContent = 'Du skickas vidare!';
                            if (cancelBtn) cancelBtn.classList.add('d-none');
                            window.location.href = redirectUrl;
                        } else if (error) {
                            showError(error);
                        } else {
                            showError("Något gick fel.");
                            throw new Error('Unexpected response from server');
                        }

                    } else {
                        showError("Något gick fel.");
                        console.error('Failed to add tickets to cart:', response.statusText);
                    }
                } catch (error) {
                    showError("Något gick fel.");
                    console.error('Error adding tickets to cart:', error);
                }
            }
        });
    }

    if (cancelBtn) {
        cancelBtn.addEventListener('click', () => {
            controller?.abort();
            if (overlay) {
                overlay.classList.add('visually-hidden');
            }
        });
    }

    function getSelectedTickets() {
        const tickets = [];
        document.querySelectorAll('input[type="number"]').forEach((input) => {
            const quantity = parseInt(input.value, 10) || 0;
            if (quantity > 0) {
                tickets.push({
                    id: input.id, // Use a unique identifier for the ticket
                    quantity: quantity,
                });
            }
        });
        return tickets;
    }

    function checkForPostError() {
        // This handles the case where the form submission was NOT made via an XHR (Ajax) request
        var errorMessage = $('#ticketError').data('post-error-message');
        if (typeof errorMessage === 'string' && errorMessage.trim() !== '') {
            showError(errorMessage);
        }
    }

    function showError(message) {
        const errorBox = document.getElementById('ticketError');
        const errorText = document.getElementById('ticketErrorText');
        if (!errorBox || !errorText) return;

        errorText.textContent = message;
        errorBox.classList.remove('d-none');
        errorBox.classList.add('show');

        if (overlay) {
            overlay.classList.add('visually-hidden');
        }
    }
}

export function reindexTicketInputs() {
    const ticketGroups = document.querySelectorAll('.accordion-body');

    let ticketIndex = 0;

    ticketGroups.forEach(group => {
        const inputs = group.querySelectorAll('[name^="Tickets["]');

        // Build a map of ticket entries by their original index
        const ticketsByOldIndex = {};

        inputs.forEach(input => {
            const match = input.name.match(/^Tickets\[(\d+)\]\.(.+)$/);
            if (!match) return;

            const [, oldIndex, prop] = match;
            ticketsByOldIndex[oldIndex] = ticketsByOldIndex[oldIndex] || {};
            ticketsByOldIndex[oldIndex][prop] = input;
        });

        // For each logical ticket (by old index), reassign to the new one
        Object.values(ticketsByOldIndex).forEach(ticketProps => {
            for (const [prop, input] of Object.entries(ticketProps)) {
                input.name = `Tickets[${ticketIndex}].${prop}`;

                if (input.classList.contains('ticket-quantity-hidden') || input.classList.contains('ticket-quantity-input')) {
                    input.setAttribute('data-ticket-index', ticketIndex);
                }
            }

            ticketIndex++;
        });
    });
}

export function configureFormInputs(root = document) {
    if (root instanceof jQuery) root = root[0]; // normalize jQuery object to DOM node
    const inputs = root.querySelectorAll('.input-group input[type="number"]');

    //Helpers
    function getTotalSelected() {
        return Array.from(inputs).reduce(
            (sum, input) => sum + (parseInt(input.value, 10) || 0),
            0
        );
    }

    function getTotalSelectedInTemplate(accordionBody) {
        return Array.from(accordionBody.querySelectorAll('input[type="number"]')).reduce(
            (sum, input) => sum + (parseInt(input.value, 10) || 0),
            0
        );
    }

    function getTotalTicketsSelected(ticketGroup) {
        return Array.from(ticketGroup.querySelectorAll('input[type="number"]')).reduce(
            (sum, input) => sum + (parseInt(input.value, 10) || 0),
            0
        );

    }

    function parseIntOr(value, fallback) {
        return parseInt(value, 10) || fallback;
    }

    inputs.forEach(input => {
        const inputGroup = input.closest('.input-group');
        const decrementBtn = inputGroup.querySelector('.btn-decrement');
        const incrementBtn = inputGroup.querySelector('.btn-increment');
        const qtyInput = inputGroup.querySelector('input[type="number"]');

        if (decrementBtn) {
            decrementBtn.addEventListener('click', () => {
                const interval = parseInt(decrementBtn.dataset.interval, 10) || 1;
                adjustTicketInput(input, -interval);
            });
        }

        if (incrementBtn) {
            incrementBtn.addEventListener('click', () => {
                const interval = parseInt(incrementBtn.dataset.interval, 10) || 1;
                adjustTicketInput(input, interval);
            });
        }

        if (qtyInput) {
            qtyInput.addEventListener('input', () => {
                if (qtyInput.value !== '') {
                    adjustTicketInput(input, 0);
                }
            });
        }

    });

    updateButtonStates();

    function adjustTicketInput(input, change = 0) {
        const accordionBody = input.closest('.accordion-body');
        const ticketGroup = document.getElementById('ticketGroupAccordion');
        const isTicket = ticketGroup?.contains(accordionBody);

        // Input-level values
        const currentValue = parseIntOr(input.value, 0);
        const interval = parseIntOr(input.dataset.interval, 1);
        const ticketMin = parseIntOr(input.dataset.min, 0);
        const ticketMax = parseIntOr(input.dataset.max, Number.MAX_SAFE_INTEGER);

        // Template/group-level values
        const templateMax = parseIntOr(accordionBody?.dataset.max, Number.MAX_SAFE_INTEGER);
        const ticketsForEventMax = parseIntOr(ticketGroup?.dataset.remaining, Number.MAX_SAFE_INTEGER);

        // Totals (excluding this input)
        const totalSelected = getTotalSelected() - currentValue;
        const totalInTemplate = accordionBody ? getTotalSelectedInTemplate(accordionBody) - currentValue : 0;
        const totalInGroup = ticketGroup ? getTotalTicketsSelected(ticketGroup) - currentValue : 0;

        // Remaining 
        const cartRemaining = MAX_TOTAL_TICKETS - totalSelected;
        const templateRemaining = templateMax - totalInTemplate;
        const groupRemaining = ticketsForEventMax - totalInGroup;

        const maxAllowed = isTicket
            ? Math.min(cartRemaining, templateRemaining, ticketMax, groupRemaining)
            : Math.min(cartRemaining, templateRemaining, ticketMax);

        let userInput = currentValue + change;

        // Always allow decreasing to 0
        if (userInput <= 0) {
            input.value = 0;
            updateButtonStates();
            updateAnnouncer();
            return;
        }

        // Adjust to interval
        let adjustedInput = Math.round(userInput / interval) * interval;

        // Cap to maxAllowed
        if (adjustedInput > maxAllowed) {
            adjustedInput = Math.floor(maxAllowed / interval) * interval;
        }

        // Enforce ticketMin (if not falling to 0)
        if (adjustedInput <= ticketMin) {
            const minStep = Math.ceil(ticketMin / interval) * interval;
            adjustedInput = (currentValue === minStep && adjustedInput < minStep) ? 0 : minStep;

            if (adjustedInput > maxAllowed) {
                adjustedInput = 0;
            }
        }

        input.value = adjustedInput;
        updateButtonStates();
        updateAnnouncer();
    }

    function updateButtonStates() {
        const ticketGroup = document.getElementById('ticketGroupAccordion');
        let ticketsForEventMax = Number.MAX_SAFE_INTEGER;
        let totalSelectedInGroup = 0;
        if (ticketGroup) {
            ticketsForEventMax = parseIntOr(ticketGroup.dataset.remaining, Number.MAX_SAFE_INTEGER);
            totalSelectedInGroup = getTotalTicketsSelected(ticketGroup);
        }
        const totalAllSelected = getTotalSelected();

        inputs.forEach(input => {
            const currentValue = parseIntOr(input.value, 0);
            const inputMin = parseIntOr(input.dataset.min, 0);
            const inputMax = parseInt(input.dataset.max, 10); // intentionally allow NaN
            const interval = parseIntOr(input.dataset.interval, 1);

            const inputGroup = input.closest('.input-group');
            const decrementBtn = inputGroup.querySelector('.btn-decrement');
            const incrementBtn = inputGroup.querySelector('.btn-increment');

            const normalizedCurrent = Math.round(currentValue / interval) * interval;

            if (decrementBtn) {
                const disableDecrement = normalizedCurrent === 0 || isNaN(normalizedCurrent);
                decrementBtn.disabled = disableDecrement;
                decrementBtn.classList.toggle('disabled', disableDecrement);
            }

            if (incrementBtn) {
                // Calculate next step value
                const nextValue = normalizedCurrent === 0
                    ? Math.ceil(Math.max(1, inputMin) / interval) * interval
                    : normalizedCurrent + interval;

                // Related template (accordion-body) and values
                const accordion = input.closest('.accordion-body');
                const templateMax = parseInt(accordion?.dataset.max, 10);
                const totalInTemplate = accordion ? getTotalSelectedInTemplate(accordion) : 0;
                const isTicket = ticketGroup ? ticketGroup.contains(accordion) : false;

                // Remaining calculations with current input excluded
                const totalIfThisIncrements = totalInTemplate - currentValue + nextValue;
                const remainingTemplate = parseIntOr(templateMax, Number.MAX_SAFE_INTEGER) - (totalInTemplate - currentValue);
                const remainingGlobal = MAX_TOTAL_TICKETS - (totalAllSelected - currentValue);
                const remainingInGroup = ticketsForEventMax - (totalSelectedInGroup - currentValue);
                // Constraint checks
                const atInputMax = !isNaN(inputMax) && nextValue > inputMax;
                const atTemplateMax = !isNaN(templateMax) && totalIfThisIncrements > templateMax;
                const atGlobalMax = remainingGlobal < nextValue;
                const atEventMax = remainingInGroup < nextValue;
                const fitsInRemaining = nextValue <= remainingTemplate;

                // Final decision for increment button
                const disableIncrement = atInputMax || atTemplateMax || atGlobalMax || !fitsInRemaining || (isTicket && atEventMax);
                incrementBtn.disabled = disableIncrement;
                incrementBtn.classList.toggle('disabled', disableIncrement);
            }
        });
        const submitBtn = document.getElementById('submitTickets');
        if (submitBtn) {
            const hasTickets = totalAllSelected > 0;
            let needsMoreTickets = false;
            inputs.forEach(input => {
                const accordionBody = input.closest('.accordion-body');
                const templateMin = accordionBody ? parseInt(accordionBody.dataset.min, 10) || 0 : 0;
                let totalInTemplate = accordionBody ? getTotalSelectedInTemplate(accordionBody) : 0;

                const addMoreToTemplateInfo = accordionBody ? document.getElementById(`add-more-for-template-${accordionBody.id}`) : null;

                if (totalInTemplate > 0 && totalInTemplate < templateMin) {
                    needsMoreTickets = true;
                    if (addMoreToTemplateInfo) {
                        addMoreToTemplateInfo.classList.remove('d-none');
                    }
                } else {
                    if (addMoreToTemplateInfo) {
                        addMoreToTemplateInfo.classList.add('d-none');
                    }
                }
            });
            submitBtn.disabled = !hasTickets || needsMoreTickets;
            const tooltip = Tooltip.getInstance(submitBtn);
            if (tooltip) {
                hasTickets ? tooltip.disable() : tooltip.enable();
            }
        }
    }
}
function updateAnnouncer() {
    const announcer = document.getElementById('ticket-announcer');
    if (!announcer) return;

    const selectedTickets = Array.from(document.querySelectorAll('input[type="number"]'))
        .filter(input => parseInt(input.value, 10) > 0)
        .map(input => {
            const quantity = parseInt(input.value, 10);
            const ticketId = input.id.startsWith('ticket-')
                ? input.id.replace('ticket-', '')
                : input.id.startsWith('package-') ? input.id.replace('package-', '')
                    : input.id.startsWith('addon-') ? input.id.replace('addon-', '')
                        : input.id;
            const nameElement = document.getElementById(`name-${ticketId}`);
            const ticketName = nameElement?.textContent.trim() || 'Okänt namn';
            return `${quantity} stycken ${ticketName}`;
        });

    announcer.textContent = selectedTickets.length > 0
        ? `Valt: ${selectedTickets.join(', ')}`
        : 'Inget valt.';
}
// Attach setupEvent to window for global access
if (typeof window !== 'undefined') {
    window.setupEvent = setupEvent;
}